import { render, staticRenderFns } from "./InviteUsers.vue?vue&type=template&id=4325f651&"
import script from "./InviteUsers.vue?vue&type=script&lang=ts&"
export * from "./InviteUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports